import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import de from '../locales/de/translation.json';
import en from '../locales/en/translation.json';

// Initialize i18n
i18n
  .use(initReactI18next)
  .init({
    lng: 'de', // Default language
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    
    resources: {
      de: {
        translation: de
      },
      en: {
        translation: en
      }
    },
    
    interpolation: {
      escapeValue: false // React already does escaping
    }
  });

// Function to change language and save to localStorage
export const changeLanguage = async (language: string) => {
  await i18n.changeLanguage(language);
  localStorage.setItem('userLanguage', language);
};

// Function to get saved language from localStorage
export const getSavedLanguage = (): string => {
  return localStorage.getItem('userLanguage') || 'de';
};

// Function to initialize language from player data or localStorage
export const initializeLanguage = (playerLanguage?: string) => {
  const savedLanguage = getSavedLanguage();
  const languageToUse = playerLanguage || savedLanguage;
  
  if (i18n.language !== languageToUse) {
    i18n.changeLanguage(languageToUse);
  }
};

export default i18n;
